export default {
    deviceManager: {
        deviceManager: 'Firmware Download',
        fwdlDetails: 'Firmware Download Details',
        fwdl: {
            "fwdlList": 'Firmware Download',
            "fwdlJobDetails": 'Firmware Download Job Details',
            "abortFwdl": 'Cancel Job',
            "approvedFirmwareVersionId" : "Approved Firmware Version ID",
            "imageId" : "Image ID",
            "sendRateMessagesPerSecond" : "Message Send Rate (msg/s)",
            "endpointType" : 'Endpoint Type',
            "ordGroupID" : 'ORD Group ID',
            "groupID" : 'Group ID',
            "returnMessage" : "Return Message",
            "active" : 'Active',
            "unicastBlockCount" : "Unicast Block Count",
            "numberOfCommsHubs" : "Comms Hubs Affected",
            "estimatedDurationMinutes" : "Estimated Duration",
            "jobId" : 'Job ID',
            "numberOfBlocksInImage" : "Blocks in Image",
            "returnCode" : "RNI Return Code",
            "jobState": "Job State",
            "errorString" : "Error String",
            "imageBlockSize" : "Image Block Size",
            "requestId" : "Request ID",
            "imageByteSize" : 'Image Byte Size',
            "carouselBlockCount" : "Carousel Block Count",
            "startDate": 'Start Date',
            "stopDate": 'Stop Date',
            "estimatedCompletionDate": 'Estimated Completion Date',
            "abortSuccess": 'Job \'{jobId}\' canceled succesfully',
            "abortFailure": "Job \'{jobId}\' is not running",
            "endpointId": 'Endpoint ID',
            'stateDetail': 'Description',
            'loadStartsSent' : 'Load Start Individual Notifications Sent',
            'loadStartsReceived' :'Device Responded To The Notification',
            'completedCarouselRounds' :  'Completed Carousel Rounds',
            'missingBlocksToRetransmit' : 'Missing Blocks To Retransmit',
            'missingBlocksAlreadyTransmitted' : 'Missing Blocks Already Transmitted',
            'imageBlocksSentSoFar': 'Image Blocks Sent So Far',
            'deliveryPointState': 'Delivery State',
            'deliveryPointStates' : {
                'NOT_STARTED': 'Not Started',
                'VALIDATION_FAILED': 'Validation Failed',
                'ACCEPTED': 'Accepted',
                'LOAD_START_SENT': 'Load Start Sent',
                'LOAD_START_ACCEPTED': 'Load Start Accepted',
                'LOAD_START_REJECTED': 'Load Start Rejected',
                'LOAD_START_TIMEOUT': 'Load Start Timeout',
                'IN_CAROUSEL': 'In Carousel',
                'IMAGE_CHECK_SENT': 'Image Check Sent',
                'MISSING_BLOCKS': 'Missing Blocks',
                'IMAGE_CHECK_FAILED': 'Image Check Failed',
                'IMAGE_CHECK_TIMEOUT': 'Image Check Timeout',
                'IMAGE_TRANSFER_SUCCESSFUL': 'Image Transfer Successful',
                'ABORT_SENT': 'Request to Cancel Sent',
                'ABORT_RECEIVED': 'Request to Cancel Received',
                'BUSY': 'Busy',
                'DISCOVERED': 'Discovered',
                'LOAD_START_SEND_FAILED': 'Load Start Send Failed',
                'IMAGE_CHECK_SEND_FAILED': 'Image Check Send Failed',
                'EXCESSIVE_MISSING_BLOCKS': 'Excessive Missing Blocks',
                'INCOMPLETE_DISCOVERY': 'Incomplete Discovery'
            },
            returnCodes: {
                'SUCCESS': 'Success',
                'INVALID_REQUEST': 'Invalid Request',
                'TOO_BUSY': 'Too Busy',
                'OTHER_ERROR': 'Other Error',
                'INVALID_COMMS_HUB_IDS': 'Invalid Comms Hub IDs',
                'REQUIRED_RESOURCES_NOT_AVAILABLE': 'Required Resources Not Available',
                'QUEUED_FOR_PROCESSING': 'Queued For Processing',
                'DUPLICATE_REQUEST': 'Duplicate Request'
            },
            jobStates: {
                PROCESSING_REQUEST: "Processing Request",
                LOAD_START: "Starting Load",
                CAROUSEL: "Carousel",
                IMAGE_CHECK: "Checking Image",
                COMPLETED: "Completed",
                EXPIRED: "Expired",
                ABORTED: "Aborted",
                READY: "Ready",
                INITIALIZING: "Initializing",
                QUEUED: "Queued",
                PLANNING: "Planning",
                REPLANNING: "Replanning",
                IN_SPLIT_TRANSACTION: "In Split Transaction",
                IN_BATCH_SUBMISSION: "In Batch Submission",
                UNICAST_BLOCKS: "Unicast Blocks"
            }
          }    
    }
}